import { createWebHistory, createRouter } from "vue-router";

import routes from './routes'
// 去除登录的路由拦截
// import { useAuthStore } from "@/store/pinia/index"
// function redirectToLogin(routeTo, next) {
//   next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
// }
const router = createRouter({
  history: createWebHistory(),

  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((routeTo, routeFrom, next) => {
  return next();
  // 去除登录的路由拦截
  // if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  //   const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
  //
  //   const auth = useAuthStore()
  //   if (!authRequired) return next()
  //   if (auth.loggedIn) {
  //     return auth.validate().then((validUser) => {
  //       validUser ? next() : redirectToLogin(routeTo, next)
  //     })
  //
  //   }
  //   redirectToLogin(routeTo, next);
  // } else if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
  //   const publicPages = ['/login', '/register', '/forgot-password'];
  //   const authpage = !publicPages.includes(routeTo.path);
  //   const loggeduser = localStorage.getItem('user');
  //   const parsedData = JSON.parse(loggeduser)
  //
  //   if (authpage && !(parsedData)) {
  //     return next('/login');
  //   }
  //   return next();
  // }
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          // Otherwise, continue resolving the route.
          resolve()
        }
      })
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return
  }

  // If we reach this point, continue resolving the route.
  next()
})

export default router
